import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log to console (or Sentry, LogRocket, etc.)
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      console.log(this.props.fallback);
      return (
        this.props.fallback({
          error: this.state.error,
          resetErrorBoundary: () =>
            this.setState({ hasError: false, error: null }),
        }) || (
          <div style={{ padding: 24 }}>
            <h2>Something went wrong 😵</h2>
            <p>Try refreshing the page.</p>

            {process.env.NODE_ENV === 'development' && (
              <pre style={{ color: 'red' }}>{this.state.error?.toString()}</pre>
            )}
          </div>
        )
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
